import PropTypes from 'prop-types'
import React from 'react'
import "./Conclusions.scss"
import PersonAvatar from '../common/PersonAvatar/PersonAvatar'
import Button from '../common/UI/Button';


function Conclusions({ subjects, rocket, decisions, location, onDone, captions }) {

    const rocketComponent = (rocket !== undefined) ? (
        <>
            <div className="column">
                <h3>Rocket</h3>
                <p>Model: {rocket.name}</p>
                {rocket.custom.map((custom, index) => (<p key={index}>{custom.description}</p>))}
            </div>
            <div className="column">
                <img src={rocket.img} alt={rocket.name} />
            </div>
        </>
    ) : null;

    const decisionsComponent = (decisions !== undefined) ? (
        <>
            <div className="column">
                <h3>Launch Decisions</h3>
                {decisions && decisions.map((decisions, index) => (<p key={index}>{decisions.description}</p>))}
                <p>Launch Location: {location.name}</p>
            </div>
        </>
    ) : null;

    return (
        <div className="conclusions-container">

            <div className="conclusions-row">
                <div className="conclusions">
                    <div className="activity">
                        <h1>{captions?.conclusionTitle}</h1>
                        <div dangerouslySetInnerHTML={{ __html: captions?.conclusionBody }}></div>
                    </div>
                </div>
                <div className="conclusions">
                    <div className="reps">
                        {subjects.map((rep, index) => (
                            <PersonAvatar
                                key={index}
                                avatar={rep.avatar}
                                name={rep.name}
                                jobtitle={rep.role}
                            />
                        ))
                        }
                    </div>
                </div>
                <div className="decisions">
                    {rocketComponent}
                    {decisionsComponent}
                </div>
            </div>

            <Button text="Next" onClickHandle={() => {
                if (onDone) {
                    onDone()
                }
            }} />

        </div>
    )
}

export default Conclusions

Conclusions.propTypes = {
    launch: PropTypes.object,
    onDone: PropTypes.func,
    rocket: PropTypes.object,
    subjects: PropTypes.array
}
